import {globalEnvironment} from './environment.global';

export const developmentEnvironment = {
  env: 'Development',
  apiUrl: 'http://localhost:4200',
  authServiceUrl: 'https://scnp.serviciosit.co:9443/qa/AuthService_qa/api/v2/',
};

export const environment = {...globalEnvironment, ...developmentEnvironment};

export const AZAURE_STAR = 'https://ca-';
export const AZAURE_END =
  '-dev.niceforest-f79e6304.eastus2.azurecontainerapps.io/api/v1/';
export const AUTH_SERVICE_AZURE = `${AZAURE_STAR}authservice${AZAURE_END}Autenticacion/`;
export const POSTS_SERVICE_AZURE = `${AZAURE_STAR}postsservice${AZAURE_END}Posts/`;
export const USER_SERVICE_AZURE = `${AZAURE_STAR}postsservice${AZAURE_END}`;
export const BENEFIT_SERVICE_AZURE = `${AZAURE_STAR}beneficiosservice${AZAURE_END}Beneficios/`;
export const DATA_USER_SERVICE_AZURE = `${AZAURE_STAR}usuariosservice${AZAURE_END}Usuarios/`;
export const DIRECTORY_SERVICE_AZURE = `${AZAURE_STAR}usuariosservice${AZAURE_END}Directorio/Buscar/`;
